import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import { BaseText, SkeletonLoader } from '@warrenbrasil/nebraska-web';
import { Accordion } from '@/modules/common/components/Accordion';
import { ProductsTable } from './components/ProductsTable';
import { Money } from '@/modules/common/components/MoneyV2';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { ISubType } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { IAllocationProducts } from './types';

interface Props {
  sections: IAllocationProducts[];
  isLoading: boolean;
  hasError: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChartProducts',
  props: {
    sections: null,
    isLoading: { type: Boolean },
    hasError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sections: IAllocationProducts[];
  isLoading: boolean;
  hasError: boolean;
}



const openSectionsMap = ref<Record<number, boolean>>({});

watch(
  () => props.sections,
  sections => {
    const newOpenSectionsMap: Record<number, boolean> = {};

    sections.forEach((_section, index) => {
      newOpenSectionsMap[index] = false;
    });

    openSectionsMap.value = newOpenSectionsMap;
  },
  { immediate: true }
);

const handleToggleAccordion = (isOpen: boolean, index: number) => {
  openSectionsMap.value[index] = isOpen;
};

function productLength(list: ISubType[]) {
  let length = 0;

  list.forEach(item => {
    length += item.allocations.length;
  });

  return length > 1 ? `${length} produtos` : `${length} produto`;
}

return { __sfc: true,props, openSectionsMap, handleToggleAccordion, productLength, BaseText, SkeletonLoader, Accordion, ProductsTable, Money, NebraskaColors }
}

})